export default "__VITE_ASSET__CCMVKzoW__"